import api from './api';

// Master data CRUD (/api/master-data). One generic surface for every md_*
// table — the column definitions come from the SERVER via getSpecs(), so the
// page builds itself and there is no second copy of the schema over here.
//
// `type` is a key from MASTER_SPECS: sites | gl_accounts | cost_centers |
// stock_codes | warehouses.
export const masterDataService = {
  // { [type]: { label, singular, key, blurb, columns: [...] } }
  getSpecs: async () => {
    const res = await api.get('/master-data/specs');
    return res.data;
  },

  // Server-side filtered, searched and paged. Returns
  // { data: rows, total, hasMore, limit } — `total` is exact here because these
  // tables are small enough to count cheaply.
  list: async (type, { filters, q, limit, offset } = {}) => {
    const res = await api.get(`/master-data/${type}`, {
      params: {
        ...(filters && Object.keys(filters).length ? { filters: JSON.stringify(filters) } : {}),
        ...(q ? { q } : {}),
        ...(limit ? { limit } : {}),
        ...(offset ? { offset } : {}),
      },
    });
    return res.data;
  },

  // Distinct values for ONE column, fetched when its filter menu opens.
  facets: async (type, col) => {
    const res = await api.get(`/master-data/${type}/facets`, { params: { col } });
    return res.data;
  },

  create: async (type, row) => {
    const res = await api.post(`/master-data/${type}`, row);
    return res.data;
  },

  // The Excel round-trip's write half.
  // payload: { mode: 'overwrite' | 'replace', rows: [...] }
  //   overwrite -> upsert by key, leaving records absent from the file alone
  //   replace   -> wipe the table first, then load
  // All or nothing: one invalid row rejects the whole file.
  bulkUpsert: async (type, payload) => {
    const res = await api.post(`/master-data/${type}/bulk`, payload);
    return res.data;
  },

  // Partial: only the fields supplied are written. The key column is ignored
  // server-side — codes are referenced elsewhere and are not renamed in place.
  update: async (type, code, patch) => {
    const res = await api.put(`/master-data/${type}/${encodeURIComponent(code)}`, patch);
    return res.data;
  },

  remove: async (type, code) => {
    const res = await api.delete(`/master-data/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};

export default masterDataService;
